// @ts-nocheck
import isApiError from "@insite/client-framework/Common/isApiError";
import loadStoreList from "@store/Framework/Store/Pages/StoreListsDetails/Handlers/LoadStoreList";
import { StoreListCustomerCollectionModel, StoreListCustomerModel } from "@store/Framework/Types/ApiModels";
import { AddSelectedShipTosApiParameter, addSelectedShipTosData } from "@store/Services/StoreListService";
import {
    createHandlerChainRunner,
    HandlerWithResult,
    markSkipOnCompleteIfOnErrorIsSet,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@toolkit/Modules/client-framework/HandlerCreator";

export interface AddStoreListCustomerResult {
    storeListCustomerCollection?: StoreListCustomerCollectionModel;
    errorMessage?: string;
}

type HandlerType = HandlerWithResult<
    {
        apiParameter: AddSelectedShipTosApiParameter;
        onSuccess?: (addedStoreListCustomer: StoreListCustomerModel[]) => void;
        onError?: (errorMessage: string) => void;
    },
    AddStoreListCustomerResult
>;

export const DispatchBeginAddCustomerListToStoreList: HandlerType = props => {
    props.result = {};
    props.dispatch({
        type: "Pages/StoreListDetails/BeginAddCustomerListToStoreList",
    });
};

export const DispatchAddCustomerListToStoreList: HandlerType = async props => {
    try {
        props.result.storeListCustomerCollection = await addSelectedShipTosData({
            storeListId: props.parameter.apiParameter.storeListId,
            storeListCustomerList: props.parameter.apiParameter.storeListCustomerList,
        });
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            props.result.errorMessage = error.errorJson.message;
            return;
        }
        throw error;
    }
};

export const ResetStoreListsData: HandlerType = props => {
    props.dispatch({
        type: "Data/StoreListDetails/Reset",
    });
    props.dispatch({
        type: "Data/StoreLists/Reset",
    });
};

export const DispatchShipTosResetDataViews: HandlerType = props => {
    props.dispatch({
        type: "Data/ShipTos/ResetDataViews",
    });
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    if (!props.result.errorMessage && props.result.storeListCustomerCollection && props.parameter.onSuccess) {
        markSkipOnCompleteIfOnSuccessIsSet(props);
        props.parameter.onSuccess(props.result.storeListCustomerCollection.storeListCustomerCollection);
    }
};

export const ExecuteOnErrorCallback: HandlerType = props => {
    if (props.result.errorMessage) {
        markSkipOnCompleteIfOnErrorIsSet(props);
        props.parameter.onError?.(props.result.errorMessage);
    }
};

export const DispatchCompleteAddCustomerListToStoreList: HandlerType = props => {
    props.dispatch({
        type: "Pages/StoreListDetails/CompleteAddCustomerListToStoreList",
        result: props.result,
    });
};

export const DispatchLoadStoreList: HandlerType = props => {
    if (!props.result.errorMessage && props.result.storeListCustomerCollection) {
        props.dispatch(loadStoreList({ storeListId: props.parameter.apiParameter.storeListId }));
    }
};

export const chain = [
    DispatchBeginAddCustomerListToStoreList,
    DispatchAddCustomerListToStoreList,
    ResetStoreListsData,
    DispatchShipTosResetDataViews,
    ExecuteOnSuccessCallback,
    ExecuteOnErrorCallback,
    DispatchCompleteAddCustomerListToStoreList,
    DispatchLoadStoreList,
];

const addSelectedShipTos = createHandlerChainRunner(chain, "AddSelectedShipTos");
export default addSelectedShipTos;
